import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Card from "react-bootstrap/Card";
import { faCalendarDays, faClipboardList, faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DashboardPage = () => {
    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <Helmet>
                            <title>Dashboard</title>
                        </Helmet>
                        <h1 className="my-3">Dashboard</h1>
                        <p className="text-muted">Welcome. Use the sidebar or the shortcuts below.</p>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export { DashboardPage };
